declare var $;

/**
 * Creates and manages toggleable UI element that fetches the contents of the toggle via AJAX.
 * Uses the cscart pattern of using the sw_ prefix for the id of the control, with matching id for the container.
 */
export class AJAXToggle {

    /**
     * @var {HTMLElement} control the element that when clicked will toggle the content. sw_ prefix on the id.
     * @var {HTMLElement} content the container to display the content in. id should match the control without sw_.
     * @var {DOMStringMap} data attributes to post with the ajax request.
     * @var {string} url controller.mode to post to.
     * @var {boolean} request_made tracks if the ajax was already performed.
     */
    control: HTMLElement;
    content: HTMLElement;
    data: DOMStringMap;
    url: string;
    request_made: boolean;

    /**
     * Add click event to the control, then initialize the data and toggle state.
     *
     * @param {HTMLElement }element to build the toggle from.
     * @returns {AJAXToggle} setup and ready.
     */
    constructor(element:HTMLElement) {
        this.control = element;
        this.content = document.getElementById(element.id.replace('sw_', ''));
        this.data = element.dataset;
        this.url = element.dataset.url;

        this.request_made = false;

        this.control.addEventListener('click', this.toggle.bind(this));
    }

    /**
     * Performs the ajax request and puts the content on the DOM.
     *
     * @returns {void}
     */
    request() : void {
        $.ceAjax('request', 'index.php?dispatch=' + this.url, {
            method: 'POST',
            cache: false,
            result_ids: this.content.id,
            callback: this.request_callback.bind(this),
            data: this.data
        });

        this.request_made = true;
    }

    /**
     * When the ajax is complete, display the contents.
     *
     * @returns {void};
     */
    request_callback() : void {
        this.toggle();
    }

    /**
     * Event handler for the control's click event.
     * Display or hide the content, and make the ajax request if needed.
     *
     * @return {void}
     */
    toggle() : void {
        if (this.request_made === false) {
            this.request();
            return;
        }

        if (this.content.classList.contains('hidden')) {
            this.content.classList.remove('hidden');
        } else {
            this.content.classList.add('hidden');
        }
    }
}
/**
 * Instantiates any of our custom ajax toggles on the page.
 *
 * @returns {void}
 */
export function init_ajax_toggles() : void {
    const detail_toggles = document.getElementsByClassName('tv-ajax-toggle') as HTMLCollectionOf<HTMLElement>;
    for (const toggle of detail_toggles) {
        (() => new AJAXToggle(toggle))();
    }
}
